import { Select, SelectProps, Button, WithActions } from "components";
import { ReactNode } from "react";
import { useGetCompaniesQuery } from "services";
import { transformCompanyToOptions } from "helpers";
import { t } from "i18next";

export interface CompanyFormProps extends Pick<SelectProps, "onChange" | "placeholder"> {
  onCancel: (state: boolean) => void;
  onNext: () => void;
  next?: string;
  title: ReactNode | string;
  companyId: string | undefined;
}

export const CompanyForm = ({
  onChange,
  onCancel,
  onNext,
  companyId,
  title,
  placeholder,
  next = "Next",
}: CompanyFormProps) => {
  const {
    data: companiesData,
    isLoading: isCompaniesLoading,
    isError: isCompaniesError,
  } = useGetCompaniesQuery({
    page: 0,
    pageSize: 100,
  });

  const companyOptions = companiesData?.companies ? transformCompanyToOptions(companiesData.companies) : [];

  return (
    <div className="flex flex-col gap-6">
      <span>{title}</span>
      {isCompaniesLoading ? (
        <div>{t("roleManagement.loadingCompanies")}</div>
      ) : isCompaniesError ? (
        <div>{t("roleManagement.errorLoadingCompanies")}</div>
      ) : (
        <Select
          options={companyOptions}
          onChange={onChange}
          name="company_id"
          value={companyId}
          placeholder={placeholder}
        />
      )}
      <WithActions closeButton={t("common.cancel")} setOpen={onCancel}>
        <Button onClick={onNext} disabled={!!!companyId}>
          {next}
        </Button>
      </WithActions>
    </div>
  );
};
